import type { FsNode } from '../types/files';

const folder = (
  id: string,
  name: string,
  parentId: string | null,
  modifiedAt: string,
  owner = 'Priya Raman',
  description?: string,
): FsNode => ({
  id,
  name,
  parentId,
  kind: 'folder',
  owner,
  modifiedBy: owner,
  modifiedAt,
  starred: false,
  trashed: false,
  description,
});

export const initialNodes: FsNode[] = [
  folder(
    'd-income',
    'Income & Employment',
    null,
    '2026-08-28T14:44:00',
    'Priya Raman',
    'Paystubs, W-2s, and employer verification for both borrowers.',
  ),
  folder(
    'd-assets',
    'Assets & Bank Statements',
    null,
    '2026-08-26T16:32:00',
    'Marcus Hale',
    'Two months of statements for every account used to source funds.',
  ),
  folder(
    'd-property',
    'Property & Appraisal',
    null,
    '2026-08-24T15:48:00',
    'Dana Whitcombe',
    'Appraisal report, comparables, and property condition photos.',
  ),
  folder('d-photos', 'Condition Photos', 'd-property', '2026-08-24T15:44:00', 'Dana Whitcombe'),
  folder(
    'd-title',
    'Title & Insurance',
    null,
    '2026-08-22T10:12:00',
    'Ellis Trask',
  ),
  folder(
    'd-closing',
    'Disclosures & Closing',
    null,
    '2026-08-27T12:01:00',
    'Priya Raman',
  ),
  folder('d-signed', 'Signed Copies', 'd-closing', '2026-08-27T11:12:00'),
  folder(
    'd-archive',
    'Prior Loan Archive',
    null,
    '2026-08-14T11:44:00',
    'Records Management',
  ),

  {
    id: 'f-01',
    name: 'Uniform Residential Loan Application (1003)',
    parentId: null,
    kind: 'file',
    type: 'pdf',
    extension: 'pdf',
    sizeKb: 1340,
    version: 4,
    owner: 'Priya Raman',
    modifiedBy: 'Priya Raman',
    modifiedAt: '2026-08-28T14:44:00',
    starred: true,
    trashed: false,
    description:
      'Master application of record. Version 4 reflects the updated employment section.',
  },
  {
    id: 'f-02',
    name: 'Underwriting Conditions Memo',
    parentId: null,
    kind: 'file',
    type: 'doc',
    extension: 'docx',
    sizeKb: 72,
    version: 2,
    owner: 'Marcus Hale',
    modifiedBy: 'Marcus Hale',
    modifiedAt: '2026-08-21T08:55:00',
    starred: true,
    trashed: false,
    description: 'Six outstanding conditions, two cleared as of last review.',
  },
  {
    id: 'f-03',
    name: 'W-2 2025 — Whitfield',
    parentId: 'd-income',
    kind: 'file',
    type: 'pdf',
    extension: 'pdf',
    sizeKb: 412,
    version: 1,
    owner: 'Jordan A. Whitfield',
    modifiedBy: 'Jordan A. Whitfield',
    modifiedAt: '2026-08-26T09:17:00',
    starred: false,
    trashed: false,
  },
  {
    id: 'f-04',
    name: 'Paystubs — Jun to Aug',
    parentId: 'd-income',
    kind: 'file',
    type: 'pdf',
    extension: 'pdf',
    sizeKb: 688,
    version: 2,
    owner: 'Jordan A. Whitfield',
    modifiedBy: 'Priya Raman',
    modifiedAt: '2026-08-25T13:22:00',
    starred: false,
    trashed: false,
  },
  {
    id: 'f-05',
    name: 'Income Verification Worksheet',
    parentId: 'd-income',
    kind: 'file',
    type: 'xls',
    extension: 'xlsx',
    sizeKb: 128,
    version: 3,
    owner: 'Priya Raman',
    modifiedBy: 'Priya Raman',
    modifiedAt: '2026-08-25T11:05:00',
    starred: false,
    trashed: false,
  },
  {
    id: 'f-06',
    name: 'Employer Verification Letter',
    parentId: 'd-income',
    kind: 'file',
    type: 'doc',
    extension: 'docx',
    sizeKb: 44,
    version: 1,
    owner: 'Priya Raman',
    modifiedBy: 'Priya Raman',
    modifiedAt: '2026-08-24T10:31:00',
    starred: false,
    trashed: false,
  },
  {
    id: 'f-07',
    name: 'Bank Statements — Q2 Consolidated',
    parentId: 'd-assets',
    kind: 'file',
    type: 'xls',
    extension: 'xlsx',
    sizeKb: 246,
    version: 2,
    owner: 'Marcus Hale',
    modifiedBy: 'Marcus Hale',
    modifiedAt: '2026-08-26T16:32:00',
    starred: false,
    trashed: false,
  },
  {
    id: 'f-08',
    name: 'Checking Account — August',
    parentId: 'd-assets',
    kind: 'file',
    type: 'pdf',
    extension: 'pdf',
    sizeKb: 318,
    version: 1,
    owner: 'Jordan A. Whitfield',
    modifiedBy: 'Jordan A. Whitfield',
    modifiedAt: '2026-08-26T08:04:00',
    starred: false,
    trashed: false,
  },
  {
    id: 'f-09',
    name: 'Credit Report Export',
    parentId: 'd-assets',
    kind: 'file',
    type: 'csv',
    extension: 'csv',
    sizeKb: 64,
    version: 1,
    owner: 'System Integration',
    modifiedBy: 'System Integration',
    modifiedAt: '2026-08-25T07:00:00',
    starred: false,
    trashed: false,
  },
  {
    id: 'f-10',
    name: 'Gift Letter — Down Payment',
    parentId: 'd-assets',
    kind: 'file',
    type: 'pdf',
    extension: 'pdf',
    sizeKb: 92,
    version: 1,
    owner: 'Priya Raman',
    modifiedBy: 'Priya Raman',
    modifiedAt: '2026-08-23T09:48:00',
    starred: false,
    trashed: false,
  },
  {
    id: 'f-11',
    name: 'Appraisal Report — 412 Larkspur Ln',
    parentId: 'd-property',
    kind: 'file',
    type: 'pdf',
    extension: 'pdf',
    sizeKb: 3180,
    version: 2,
    owner: 'Dana Whitcombe',
    modifiedBy: 'Dana Whitcombe',
    modifiedAt: '2026-08-24T15:48:00',
    starred: true,
    trashed: false,
    description: 'Appraised value $512,000. Supports the requested loan amount.',
  },
  {
    id: 'f-12',
    name: 'Comparable Sales Grid',
    parentId: 'd-property',
    kind: 'file',
    type: 'xls',
    extension: 'xlsx',
    sizeKb: 156,
    version: 1,
    owner: 'Dana Whitcombe',
    modifiedBy: 'Dana Whitcombe',
    modifiedAt: '2026-08-24T15:46:00',
    starred: false,
    trashed: false,
  },
  {
    id: 'f-13',
    name: 'Property Photo — Exterior',
    parentId: 'd-photos',
    kind: 'file',
    type: 'img',
    extension: 'jpg',
    sizeKb: 2260,
    version: 1,
    owner: 'Dana Whitcombe',
    modifiedBy: 'Dana Whitcombe',
    modifiedAt: '2026-08-24T15:44:00',
    starred: false,
    trashed: false,
    thumbnailUrl:
      'https://cdn.magicpatterns.com/patterns/generated-images/b4702501-ec64-40f0-8576-bf9dbc437f8a.jpg',
  },
  {
    id: 'f-14',
    name: 'Property Photo — Kitchen Remodel',
    parentId: 'd-photos',
    kind: 'file',
    type: 'img',
    extension: 'png',
    sizeKb: 1720,
    version: 1,
    owner: 'Jordan A. Whitfield',
    modifiedBy: 'Jordan A. Whitfield',
    modifiedAt: '2026-08-23T18:21:00',
    starred: true,
    trashed: false,
    thumbnailUrl:
      'https://cdn.magicpatterns.com/patterns/generated-images/9dd29f83-6478-4ec9-96af-b4a82cde140c.jpg',
  },
  {
    id: 'f-15',
    name: 'Title Commitment Letter',
    parentId: 'd-title',
    kind: 'file',
    type: 'doc',
    extension: 'docx',
    sizeKb: 96,
    version: 1,
    owner: 'Ellis Trask',
    modifiedBy: 'Ellis Trask',
    modifiedAt: '2026-08-21T13:39:00',
    starred: false,
    trashed: false,
  },
  {
    id: 'f-16',
    name: 'Homeowners Insurance Binder',
    parentId: 'd-title',
    kind: 'file',
    type: 'pdf',
    extension: 'pdf',
    sizeKb: 540,
    version: 1,
    owner: 'Jordan A. Whitfield',
    modifiedBy: 'Priya Raman',
    modifiedAt: '2026-08-22T10:12:00',
    starred: false,
    trashed: false,
  },
  {
    id: 'f-17',
    name: 'Flood Certification',
    parentId: 'd-title',
    kind: 'file',
    type: 'txt',
    extension: 'txt',
    sizeKb: 6,
    version: 1,
    owner: 'System Integration',
    modifiedBy: 'System Integration',
    modifiedAt: '2026-08-20T06:30:00',
    starred: false,
    trashed: false,
  },
  {
    id: 'f-18',
    name: 'Closing Disclosure — Preliminary',
    parentId: 'd-closing',
    kind: 'file',
    type: 'pdf',
    extension: 'pdf',
    sizeKb: 878,
    version: 3,
    owner: 'Priya Raman',
    modifiedBy: 'Marcus Hale',
    modifiedAt: '2026-08-27T12:01:00',
    starred: false,
    trashed: false,
  },
  {
    id: 'f-19',
    name: 'Rate Lock Confirmation Email',
    parentId: 'd-closing',
    kind: 'file',
    type: 'html',
    extension: 'html',
    sizeKb: 22,
    version: 1,
    owner: 'System Integration',
    modifiedBy: 'System Integration',
    modifiedAt: '2026-08-18T09:26:00',
    starred: false,
    trashed: false,
  },
  {
    id: 'f-20',
    name: 'Borrower Onboarding Deck',
    parentId: 'd-closing',
    kind: 'file',
    type: 'ppt',
    extension: 'pptx',
    sizeKb: 4420,
    version: 1,
    owner: 'Priya Raman',
    modifiedBy: 'Priya Raman',
    modifiedAt: '2026-08-19T17:02:00',
    starred: false,
    trashed: false,
  },
  {
    id: 'f-21',
    name: 'Initial Disclosures — Signed',
    parentId: 'd-signed',
    kind: 'file',
    type: 'pdf',
    extension: 'pdf',
    sizeKb: 1120,
    version: 1,
    owner: 'Jordan A. Whitfield',
    modifiedBy: 'Jordan A. Whitfield',
    modifiedAt: '2026-08-27T11:12:00',
    starred: false,
    trashed: false,
  },
  {
    id: 'f-22',
    name: 'Intent to Proceed — Signed',
    parentId: 'd-signed',
    kind: 'file',
    type: 'pdf',
    extension: 'pdf',
    sizeKb: 84,
    version: 1,
    owner: 'Jordan A. Whitfield',
    modifiedBy: 'Jordan A. Whitfield',
    modifiedAt: '2026-08-27T11:09:00',
    starred: false,
    trashed: false,
  },
  {
    id: 'f-23',
    name: 'Prior Loan Package (2019)',
    parentId: 'd-archive',
    kind: 'file',
    type: 'zip',
    extension: 'zip',
    sizeKb: 6890,
    version: 1,
    owner: 'Records Management',
    modifiedBy: 'Records Management',
    modifiedAt: '2026-08-14T11:44:00',
    starred: false,
    trashed: false,
  },
  {
    id: 'f-24',
    name: 'Call Notes — Escrow Follow-up',
    parentId: 'd-archive',
    kind: 'file',
    type: 'txt',
    extension: 'txt',
    sizeKb: 8,
    version: 1,
    owner: 'Priya Raman',
    modifiedBy: 'Priya Raman',
    modifiedAt: '2026-08-17T14:10:00',
    starred: false,
    trashed: false,
  },
  {
    id: 'f-25',
    name: 'Duplicate — Checking Account July',
    parentId: 'd-assets',
    kind: 'file',
    type: 'pdf',
    extension: 'pdf',
    sizeKb: 302,
    version: 1,
    owner: 'Marcus Hale',
    modifiedBy: 'Marcus Hale',
    modifiedAt: '2026-08-22T16:02:00',
    starred: false,
    trashed: true,
  },
  {
    id: 'f-26',
    name: 'Old Appraisal Draft',
    parentId: 'd-property',
    kind: 'file',
    type: 'pdf',
    extension: 'pdf',
    sizeKb: 2980,
    version: 1,
    owner: 'Dana Whitcombe',
    modifiedBy: 'Dana Whitcombe',
    modifiedAt: '2026-08-20T09:15:00',
    starred: false,
    trashed: true,
  },
];
